import React, {Component} from 'react';
import RarocHeader from '../../Dashboard/Header/Header';
import './style.scss';
import RwaTable from './RwaTable';

export class Rwa extends Component {
  render() {
    return (
      <div className='RWAcontainer card'>
        <RarocHeader title='RWA THEO ĐỐI TƯỢNG KHÁCH HÀNG - THỜI ĐIỂM' />
        <RwaTable />
      </div>
    );
  }
}

export default Rwa;



// WEBPACK FOOTER //
// src/pages/Raroc/Report/RWA/index.js